module.exports = __webpack_public_path__ + "static/media/three-js-playground.a1d29be8.jpg";